export const TOP_UP_POINTS_THRESHOLDS = {
	2000: 40,
	5000: 150,
	10000: 400,
	20000: 1000,
};

const thresholdEntriesAscending = Object.entries(TOP_UP_POINTS_THRESHOLDS)
	.map(([topUpAmount, points]) => ({
		topUpAmount: Number(topUpAmount),
		points,
	}))
	.sort((a, b) => a.topUpAmount - b.topUpAmount);

export const MAX_TOP_UP_POINTS_THRESHOLD_AMOUNT = thresholdEntriesAscending.reduce((maxAmount, threshold) => {
	return Math.max(maxAmount, threshold.topUpAmount);
}, 0);

export function getTopUpBonusPoints (topUpAmount) {
	const normalizedAmount = Number(topUpAmount) || 0;

	if (normalizedAmount <= 0) {
		return 0;
	}

	let awardedPoints = 0;

	for (const threshold of thresholdEntriesAscending) {
		if (normalizedAmount >= threshold.topUpAmount) {
			awardedPoints = threshold.points;
			continue;
		}
		break;
	}

	return awardedPoints;
}
